import useSWR from "swr";
import unauthAxios, { unauthAxiosFetcher } from "../axios";
import authAxios from "../authAxios";

export const useProject = (projectId, projectSlug, getFromCache = true) => {
  const url = projectId
    ? `/v1/project/getProjectById?project_id=${projectId}&getFromCache=${getFromCache}`
    : projectSlug
      ? `/v1/project/getProjectBySlug?project_slug=${projectSlug}&getFromCache=${getFromCache}`
      : null;

  return useSWR(url, unauthAxiosFetcher);
};

export const getProject = (projectId, projectSlug, getFromCache = false) => {
  const url = projectId
    ? `/v1/project/getProjectById?project_id=${projectId}&getFromCache=${getFromCache}`
    : projectSlug
      ? `/v1/project/getProjectBySlug?project_slug=${projectSlug}&getFromCache=${getFromCache}`
      : null;

  return unauthAxios.get(url);
};

export const getProjectCanStartNewDateWithoutApproval = (
  project_id,
  trip_start_date,
  trip_end_date,
  allow_public_trip_creation,
  guest_count,
  trip_min_slots,
  trip_days_before_all_nonrefundable,
  trip_days_before_deposit_nonrefundable
) =>
  unauthAxios.post(`/v1/project/getProjectCanStartNewDateWithoutApproval`, {
    project_id,
    trip_start_date,
    trip_end_date,
    allow_public_trip_creation,
    guest_count,
    trip_min_slots,
    trip_days_before_all_nonrefundable,
    trip_days_before_deposit_nonrefundable,
  });

export const useProjects = () => useSWR("v1/project/getAllProjects", unauthAxiosFetcher);

export const useRelatedProjects = (project_id) =>
  useSWR(
    project_id ? `/v1/project/getRelatedProjects?project_id=${project_id}&limit=10` : null,
    unauthAxiosFetcher
  );

export const useProjectTrips = (project_id) => {
  return useSWR(
    project_id ? `/v1/project/getProjectTrips?project_id=${project_id}` : null,
    unauthAxiosFetcher
  );
};

export const useProjectItinerary = (project_id) =>
  useSWR(
    project_id ? `/v1/project/getProjectItinerary?project_id=${project_id}` : null,
    unauthAxiosFetcher
  );

export const useProjectItineraryHighlights = (project_id) =>
  useSWR(
    project_id ? `/v1/project/getProjectItineraryHighlights?project_id=${project_id}` : null,
    unauthAxiosFetcher
  );

export const getProjectCommonQuestions = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectCommonQuestions?project_id=${project_id}`);

export const getProjectTrips = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectTrips?project_id=${project_id}`);

export const getProjectItinerary = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectItinerary?project_id=${project_id}`);

export const getProjectTimeSlots = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectTimeSlots?project_id=${project_id}`);

export const getProjectItineraryHighlights = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectItineraryHighlights?project_id=${project_id}`);

export const incrementItineraryHighlightClicks = (highlight_id) =>
  unauthAxios.post(`/v1/project/incrementItineraryHighlightClicks`, { highlight_id });

export const incrementMemoryClicks = (memory_id) =>
  unauthAxios.post(`/v1/project/incrementMemoryClicks`, { memory_id });

export const getProjectAccommodationHighlights = (project_id) =>
  unauthAxios.get(`/v1/project/getProjectAccommodationHighlights?project_id=${project_id}`);

export const getDisabledProjectDates = (project_id) =>
  unauthAxios.get(`/v1/project/getDisabledProjectDates?project_id=${project_id}`);

export const recordTripRequest = (
  project_id,
  trip_start_date,
  trip_end_date,
  estimated_number_of_pax
) =>
  authAxios.post(`/v1/project/recordTripRequest`, {
    project_id,
    trip_start_date,
    trip_end_date,
    estimated_number_of_pax,
  });

export const generateProjectAIAnswer = (project_id, question, conversationContext = []) =>
  authAxios.post(`/v1/project/generateProjectAIAnswer`, {
    project_id,
    question,
    conversationContext,
  });

export const getLeaderDocsByProjectId = (project_id) =>
  unauthAxios.get(`/v1/cms/docs/project/${project_id}/trip-leader-instructions`);
